import { UserDataFragment } from 'types/graphql'

import { formatUserName } from 'src/utils'

export const getOptionFromUser = (u: UserDataFragment) => {
  return {
    label: formatUserName(u),
    value: u,
  }
}
